import Table from "react-bootstrap/Table";
import React, { useState, useEffect, Component } from "react";

import { request } from "graphql-request";
import ReactPaginate from "react-paginate";

const TableView = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(15);
  if (!props.data) {
    return <div>Loading...</div>;
  }

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentItems = props.data.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  return (
    <div>
      <Table responsive hover size="sm" striped="columns">
        <thead>
          <tr>
            {props.tTitle
              ? props.tTitle.map((column) => (
                  <th className="text-center color-white" key={column.id}>
                    {column}
                  </th>
                ))
              : props.columns.map((column) => (
                  <th className="text-center color-white" key={column.id}>
                    {column}
                  </th>
                ))}
          </tr>
        </thead>
        <tbody>
          {currentItems.map((row) => (
            <tr key={row.id} onClick={() => props.setSelectedRow(row.id)}>
              {props.columns.map((column) => (
                <td className="text-center color-white" key={column}>
                  {row[column]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
      <ReactPaginate
        onPageChange={paginate}
        pageCount={Math.ceil(props.data.length / postsPerPage)}
        previousLabel={"Prev"}
        nextLabel={"Next"}
        containerClassName={"pagination"}
        pageLinkClassName={"page-number"}
        previousLinkClassName={"page-number"}
        nextLinkClassName={"page-number"}
        activeLinkClassName={"active"}
      />
    </div>
  );
};

export default TableView;
